import { EventBus, type EventsMap } from '@databases/event-bus';

/**
 * Defines the mapping between event names and their associated payload structures.
 * Each key represents an event name used during dispatch, and the value specifies
 * the payload shape received by the event listener.
 */
export interface CoreEventBusEvents extends EventsMap {
  /**
   * Fired when an event from the MutationObserver is triggered, meaning the bridge data has changed in some way.
   * For now, this only tracks the old contentId and the new contentId.
   */
  bridgeDataChanged: {
    oldContentId: string;
    newContentId: string;
  };

  /**
   * Fired when the database's content ID has changed.
   */
  databaseContentIdChanged: null;

  /**
   * This only happens from dev tools and can eventually be deprecated. This event fires when the local dev UI changes
   * feature flag state but our feature flag state is primarily non-reactive. So, a page refresh is usually required.
   */
  featureFlagsChanged: Record<string, boolean>;
  /** Fired when we want to show the action bar due to database selections. */
  showActionBar: null;
  /** Fired when we want to hide the action bar. */
  hideActionBar: null;
  /** Fired when Databases shows a context menu and wants Whiteboards to dismiss theirs. */
  databaseContextMenuShown: null;
}

export class CoreEventBus extends EventBus<CoreEventBusEvents> {}
